import {filter, keys, map, size, some} from 'lodash';

import RecommendationAnnotationTags from 'components/RecommendationAnnotation/Tags';
import HtmlContainer from 'components/shared/html_container';
import Types from 'conf/types';
import {compactObject} from 'helpers/util';

export default function RecommendationAnnotation({
  implications = [], text, moreText, genotypes, phenotypes, lookupKey,
  classification, population = 'unspecified',
  alternateDrugAvailable = false,
  dosingInformation = false,
  otherPrescribingGuidance = false,
  recommendationTitle = 'Recommendation',
  populationTitle = 'Group',
  multipopulation = false,
  parentCls, parentSource,
}) {
  const isPgxAssoc = parentCls === Types.pGxAssociation.displayType;
  const displayPopulation = isPgxAssoc ? population.replace('Affected subgroup: ', '') : population;
  const isHla = some(keys(lookupKey), (gene) => gene.startsWith('HLA'));
  return (
    <div className="recommendationAnnotation">
      {lookupKey && (
        <RecommendationAnnotationTags
          alternateDrugAvailable={alternateDrugAvailable}
          otherPrescribingGuidance={otherPrescribingGuidance}
          dosingInformation={dosingInformation}
        />
      )}
      <dl>
        {size(genotypes) > 0 && (
          <>
            <dt>Submitted Genotype</dt>
            <dd>
              <ul className="list-unstyled mb-0">
                {map(keys(genotypes), (gene) => <li key={gene}>{gene}: {genotypes[gene]}</li>)}
              </ul>
            </dd>
          </>
        )}
        {(size(compactObject(phenotypes)) > 0 || (size(lookupKey) > 0 && isHla)) && (
          <>
            <dt>Matched Phenotype</dt>
            <dd>
              {size(phenotypes) > 0 && (
                <ul className="list-unstyled mb-0">
                  {map(keys(phenotypes), (gene) => <li key={gene}>{gene}: {phenotypes[gene]}</li>)}
                </ul>
              )}
              {/* HLA's (and only HLA's) can fall back to the lookupKey for the phenotype value */}
              {size(phenotypes) === 0 && size(lookupKey) > 0 && isHla && (
                <ul className="list-unstyled mb-0">
                  {map(filter(keys(lookupKey), (gene) => gene.startsWith('HLA')), (gene) =>
                    <li key={gene}>{gene}: {lookupKey[gene]}</li>)}
                </ul>
              )}
            </dd>
          </>
        )}

        {(multipopulation || isPgxAssoc) && (
          <>
            <dt>{populationTitle}</dt>
            <dd>{displayPopulation}</dd>
          </>
        )}

        {implications?.length > 0 && (
          <>
            <dt>Implications</dt>
            <dd>
              <ul className="list-unstyled mb-0">
                {map(implications, (implication) => <li key={implication}>{implication}</li>)}
              </ul>
            </dd>
          </>
        )}

        <dt>{recommendationTitle}</dt>
        <dd>
          <HtmlContainer html={text?.html || 'This genotype/phenotype has no recommendation.'} />
          {moreText && <HtmlContainer html={moreText?.html} className="mt-2" />}
        </dd>
        {parentSource === 'CPIC' && classification?.term && (
          <>
            <dt>Recommendation Strength</dt>
            <dd>{classification?.term}</dd>
          </>
        )}
      </dl>
    </div>
  );
}
